import Section from '@/components/ui/Section';
import styled from 'styled-components';

const AdjustedSection = styled(Section)`
  position: relative;
  padding-bottom: 6rem;

  header h1 {
    margin-bottom: 6rem;
  }
`;

export { AdjustedSection };
